var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.639 2.52782L12.219 4.86115C11.7277 3.66572 10.8407 2.67527 9.70647 2.05552C8.57227 1.43578 7.25964 1.22433 5.98819 1.45655C4.71675 1.68877 3.56361 2.35058 2.72171 3.33125C1.87981 4.31191 1.40022 5.55196 1.36317 6.8439M1.36084 11.4727L1.78084 9.13932C2.27222 10.3348 3.15924 11.3253 4.2935 11.945C5.42777 12.5647 6.74045 12.7761 8.01193 12.5438C9.2834 12.3115 10.4365 11.6496 11.2784 10.6689C12.1202 9.68811 12.5998 8.44798 12.6367 7.15599",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.361 4.86108H6.51417C6.23118 4.86123 5.95977 4.97343 5.75929 5.17315C5.55881 5.37287 5.44557 5.64385 5.44434 5.92683C5.44434 6.51775 5.92267 7.00016 6.51417 7.00016H7.486C8.07634 7.00016 8.55584 7.48258 8.55584 8.06591C8.55584 8.34997 8.44323 8.62245 8.2427 8.82364C8.04217 9.02483 7.77006 9.13832 7.486 9.13925H5.63917M7.00009 4.0835V4.86108M7.00009 9.91683V9.13925",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareSubscriptionIcon);
export default __webpack_public_path__ + "static/media/software_subscription_icon.68863a0f9c3721067b51b748c0a16892.svg";
export { ForwardRef as ReactComponent };